<template>
  <div class="app-container">
    <div
      class="toolbar"
      style="float: left; padding-top: 10px; text-align: left; width: 100%"
    >
      <el-form :inline="true" :model="filters" :size="size">
        <el-form-item label="名称" prop="name">
          <el-input
            clearable
            v-model.number="filters.name"
            placeholder="请输入名称"
            auto-complete="off"
          ></el-input>
        </el-form-item>
        <el-button
          class="el-icon-search"
          :size="size"
          type="primary"
          @click="getList()"
          >搜索</el-button
        >
      </el-form>
    </div>
    <div class="table-list">
      <div class="addToolbar">
        <el-button type="primary" :size="size" @click="handleCreate"
          >新增</el-button
        >
        <el-form :inline="true" :size="size" style="float: right">
          <el-form-item>
            <el-button-group>
              <el-tooltip content="刷新" placement="top">
                <el-button icon="fa el-icon-refresh" @click="getList()" />
              </el-tooltip>
            </el-button-group>
          </el-form-item>
        </el-form>
      </div>

      <el-table :data="tableData.data" style="width: 100%" height="534">
        <el-table-column
          label="分组名称"
          prop="name"
          width="300"
          show-overflow-tooltip
        />
        <el-table-column
          label="描述"
          prop="describe"
          width="300"
          show-overflow-tooltip
        />
        <el-table-column label="图标" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.icon == ''">暂无</span>
            <span v-else>
              <el-image
                style="width: 50px; height: 50px; border-radius: 50%"
                :src="row.icon"
                :preview-src-list="row.icon.split(',')"
                @click.stop="handleClickStop"
              >
              </el-image>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="sort" align="center" width="120" />
        <el-table-column fixed="right" label="操作" width="190">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="handleUpdate(scope.row)"
              >修改</el-button
            >
            <el-button
              type="danger"
              size="mini"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--新增编辑界面-->
    <el-drawer
      :title="textMap[dialogStatus]"
      :visible.sync="dialogFormVisible"
      destroy-on-close
      class="editdrawer"
      size="26%"
    >
      <el-form
        ref="formRef"
        :model="dataform"
        :rules="rules"
        :disabled="dialogStatus == 'detail'"
        label-width="70px"
      >
        <el-form-item label="名称" prop="name">
          <el-input v-model="dataform.name" placeholder="请输入分组名称">
          </el-input>
        </el-form-item>
        <el-form-item label="图标" prop="icon">
          <el-upload
            class="avatar-uploader"
            :action="url"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img
              v-if="dataform.icon != ''"
              :src="dataform.icon"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="描述" prop="describe">
          <el-input v-model="dataform.describe" placeholder="请输入描述">
          </el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number
            v-model.number="dataform.sort"
            controls-position="right"
            :min="0"
            clearable
          />
        </el-form-item>
      </el-form>
      <div class="demo-drawer__footer" v-if="dialogStatus != 'detail'">
        <el-button @click="cancelForm">取 消</el-button>
        <el-button type="primary" @click.native="createData">保存</el-button>
      </div>
    </el-drawer>
  </div>
</template>
    <script>
import {
  insertGlobalTptGroupo,
  updateGlobalTptGroupo,
  DeleteGlobalTptGroupo,
  GetGlobalTptGroupoPage,
} from "@/api/Industry";
import config from "@/config/index";
export default {
  components: {},
  data() {
    return {
      size: "mini",
      url: config.apiUploadUrl,
      rules: {
        icon: [
          { required: true, message: "请上传分组图标", trigger: "change" },
        ],
        name: [{ required: true, message: "请输入分组名称", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
      },
      dialogFormVisible: false,
      tableData: [],
      filters: {
        name: "",
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
      },
      dialogStatus: "",
      dataform: {
        // GroupId: 0, //工作分类id、
        name: "", //分类名称、
        describe: "",
        icon: "", //图标路径、
        sort: 0,
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
      },
      textMap: {
        update: "修改",
        create: "新增",
        detail: "分类详情",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取分类
    getList: function () {
      this.loading = true;
      GetGlobalTptGroupoPage(this.filters)
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res;
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleDelete(row) {
      this.$confirm("确定要删除该模板分组吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      }).then(() => {
        this.fullLoading = true;
        DeleteGlobalTptGroupo({ id: row.id })
          .then((res) => {
            if (res.code === 200) {
              this.$message({ message: "删除成功", type: "success" });
              this.fullLoading = false;
              this.getList();
            } else {
              this.$message({ message: "删除失败" + res.msg, type: "error" });
            }
          })
          .catch(() => {
            this.fullLoading = false;
          });
      });
    },
    resetTemp() {
      this.dataform = {
        // GroupId: 0, //工作分类id、
        name: "", //分类名称、
        describe: "",
        icon: "", //图标路径、
        sort: 0,
        companyId: this.$route.query.EId,
        platformId: this.$route.query.platformId,
      };
    },
    handleClickStop() {
      this.$nextTick(() => {
        let domImageView = document.querySelector(".el-image-viewer__mask"); // 获取遮罩层dom
        if (!domImageView) {
          return;
        }
        domImageView.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      });
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["formRef"].clearValidate();
      });
    },
    cancelForm() {
      this.dialogFormVisible = false;
    },
    createData() {
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          this.fullLoading = true;
          const tempDataForm = Object.assign({}, this.dataform);
          if (tempDataForm.id != null) {
            updateGlobalTptGroupo(tempDataForm)
              .then((res) => {
                this.fullLoading = false;
                this.dialogFormVisible = false;
                if (res.code === 200) {
                  this.$message({ message: "修改成功", type: "success" });
                  this.getList();
                } else {
                  this.$message({
                    message: "操作失败, " + res.msg,
                    type: "error",
                  });
                }
              })
              .catch(() => {
                this.fullLoading = false;
                this.dialogFormVisible = false;
              });
          } else {
            insertGlobalTptGroupo(tempDataForm)
              .then((res) => {
                this.fullLoading = false;
                this.dialogFormVisible = false;
                if (res.code === 200) {
                  this.$message({ message: "新增成功", type: "success" });
                  this.getList();
                } else {
                  this.$message({
                    message: "操作失败, " + res.msg,
                    type: "error",
                  });
                }
              })
              .catch(() => {
                this.fullLoading = false;
                this.dialogFormVisible = false;
              });
          }
        }
      });
    },
    handleUpdate(row) {
      this.dataform = Object.assign({}, row); // copy obj
      console.log(this.dataform);
      // if (this.dataform.ParentId == "0") {
      //   this.dataform.ParentName = "顶级菜单";
      // }
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["formRef"].clearValidate();
      });
    },
    // 上传图片
    handleUploadSuccess(res, file) {
      this.dataform.icon = res.data;
      return false;
    },
    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
  },
};
</script>

<style scoped>
/deep/ .avatar-uploader-icon {
  width: 130px;
  height: 130px;
}

/deep/ .avatar-uploader-icon {
  line-height: 130px;
}
</style>
    